<template>
  <div class="s-my-submission-container">
    <div class="s-dealmakers-list-wrap" v-if="matchUpList.length > 0">
      <div
        class="s-transaction-item" style="margin: 0"
        v-for="(item, index) in matchUpList"
        :key="index"
      >
        <div class="stateBox" v-if="item.dataStatus">
          <span v-if="item.dataStatus == '0'">正常</span>
          <span v-if="item.dataStatus == '1'">已关闭</span>
          <span v-if="item.dataStatus == '2'">已交易</span>
          <!-- <span v-if="item.dataStatus == '3'">求购</span>
            <span v-if="item.dataStatus == '4'">供应</span>
            <span v-if="item.dataStatus == '5'">撮合</span> -->
        </div>
        <div class="expert-img">
          <img v-if="item.img !=null && item.img !='' && item.img.indexOf('http') >=0" :src="item.img" alt />
          <img v-else :src="imgURL + '/' + item.img" alt />
        </div>
        <div class="baseinfo-1">
          <div class="base-info-title">{{ item.transactionTitle  || '--'}}</div>
          <div>
            <span class="span-title">地区：</span>
            {{ item.proninceValue  || '--'}}{{ item.countyValue  || '--'}}
          </div>
          <div>
            <span class="span-title">详细地址：</span>
            {{ item.address || '--'}}
          </div>
          <div>
            <span class="span-title">联系电话：</span>
            {{ item.contactsPhone  || '--'}}
          </div>
          <div>
            <span class="span-title">产品类型：</span>
            {{ item.matchUpType  || '--'}}
          </div>
        </div>
        <div class="baseinfo-2">
          <div>
            <span class="span-title">数量：</span>
            {{ item.transactionNumber  || '--'}}{{ item.numberUnit }}
          </div>
          <div>
            <span class="span-title">价格：</span>
            {{ item.transactionPrice  || '--'}}{{ item.priceUnit }}
          </div>

          <div>
            <span class="span-title">时间：</span>
            {{ item.transactionDate }}
          </div>
        </div>
        <div class="btnBox">
          <el-button type="success" @click="changeStats(item.id, '1', '撮合')"
            >关闭</el-button
          >
          <el-button type="success" @click="changeStats(item.id, '2', '撮合')"
            >已交易</el-button
          >
        </div>
      </div>
    </div>
    <div v-else>
        <el-empty description="暂无数据！" :image="noDataImg" :image-size="400"></el-empty>
    </div>
    <el-pagination
      v-if="matchUpList.length > 0"
      class="tab_pagination"
      background
      :pageSize="pageSize"
      layout="prev, pager, next"
      @current-change="currentChange"
      :total="total"
    ></el-pagination>
  </div>
</template>

<script>
import {
  getMatchUpListByUserId,
  matchUpdate,
} from "../utils/api/specialistPerson";
export default {
  name: "my-submission",
  data() {
    return {
      matchUpList: [],
      currentPage: 1, // 页码
      pageSize: 10, // 每页显示数量
      total: 0, // 总数
      noDataImg:require('../assets/image/pest/no-data.jpg')
    };
  },
  mounted() {
    this.getMatchUpListByUserId();
  },
  methods: {
    currentChange(value) {
      this.currentPage = value;
      this.getMatchUpListByUserId();
    },
    async getMatchUpListByUserId() {
      let params = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
      };
      let res = await getMatchUpListByUserId(params);
      if (res.data.code == 0) {
        this.matchUpList = res.data.data.records;
        this.total = res.data.data.total;
      }
    },
    async changeStats(id, stats, name) {
      let data = {
        id: id,
        dataStatus: stats,
      };
      this.currentPage = 1;
      if (name == "撮合") {
        let res = await matchUpdate(data);
        if (res.data.code == 0) {
          this.$message({
            message: "状态更改成功！",
            type: "success",
          });
          this.getMatchUpListByUserId();
        }
      }
    },
  },
};
</script>

<style lang="scss">
@import "../utils/css/common.scss";
@import "../utils/css/personalCenter.scss";
</style>
